import React from 'react'
import { FaSearch, FaFilter } from 'react-icons/fa'

/**
 * Header used on "Mine turer" and "Mine skift": a filter button and a
 * free-text search field, matching the blue pill style from the design.
 */
const FilterHeader = ({ searchValue, onSearchChange, onFilterClick, placeholder = 'Fritekst søk ...', activeFilterCount = 0 }) => {
   return (
      <div className="flex items-center gap-2 bg-blue-500 rounded-full px-2 py-2 shadow-sm">
         <button
            onClick={onFilterClick}
            className="relative flex items-center gap-1 bg-blue-400 bg-opacity-60 text-white text-sm md:text-base rounded-full px-3 py-2 focus:outline-none">
            <FaFilter size={12} />
            Filter
            {activeFilterCount > 0 && (
               <span className="absolute -top-1 -right-1 flex items-center justify-center bg-red-500 text-white text-xs md:text-sm font-semibold rounded-full h-5 w-5">
                  {activeFilterCount}
               </span>
            )}
         </button>
         <div className="flex items-center flex-1 bg-white rounded-full px-3 py-2">
            <FaSearch className="text-gray-400 mr-2" size={12} />
            <input
               value={searchValue}
               onChange={e => onSearchChange && onSearchChange(e.target.value)}
               placeholder={placeholder}
               className="w-full text-sm md:text-base outline-none"
            />
         </div>
      </div>
   )
}

export default FilterHeader
